import PageContainer from '@Guidelines/Layout/PageContainer';
import PageHeader from '@Guidelines/Layout/PageHeader';
import AiCostLimitsContent from '@UI/Pages/Administration/AiCostLimits/AiCostLimitsContent';
import AiCostLimitsNotifications from '@UI/Pages/Administration/AiCostLimits/AiCostLimitsNotifications';
import AiCostLimitFormNotifications from '@UI/Pages/Administration/Shared/AiCostLimitFormNotifications';
import type * as React from 'react';

const AiCostLimitsPage: React.FC = () => {
	return (
		<PageContainer>
			<PageHeader
				eyebrow="CONFIGURATION"
				title="Plafonds de coûts d'IA"
				description="Plafonds mensuels du coût estimé des traitements d'IA. Au plafond, aucun nouveau traitement ne démarre ; un traitement déjà lancé va à son terme. Le décompte repart le 1er de chaque mois."
			/>
			<AiCostLimitsContent />
			<AiCostLimitsNotifications />
			<AiCostLimitFormNotifications />
		</PageContainer>
	);
};

export default AiCostLimitsPage;
